import { get, post, remove } from "./api";

export type McpConnection = {
  id: string;
  workspaceId: string;
  userId: string;
  clientName: string;
  scopes: string[];
  createdAt: string;
  lastUsedAt?: string | null;
  revokedAt?: string | null;
};

export async function listMcpConnections(workspaceId: string): Promise<McpConnection[]> {
  const { data } = await get({ path: `/${workspaceId}/mcp/connections` });
  return data || [];
}

export async function revokeMcpConnection(workspaceId: string, connectionId: string): Promise<void> {
  await remove({ path: `/${workspaceId}/mcp/connections/${connectionId}` });
}

export async function getMcpScopesCatalog(): Promise<{
  scopes: string[];
  labels: Record<string, string>;
}> {
  const { data } = await get({ path: `/mcp/scopes` });
  return data;
}

export async function submitMcpOAuthConsent(body: {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  codeChallengeMethod?: string;
  workspaceId: string;
  scope?: string;
  state?: string | null;
}): Promise<{ redirectUrl: string }> {
  const { data } = await post({ path: `/mcp/oauth/consent`, data: body });
  return data;
}
